import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const MuteluIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "MuteluIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M8.96178 6.07716C8.93674 6.24341 8.86606 6.36443 8.71855 6.43356C8.56761 6.5043 8.40551 6.50221 8.28335 6.3917C7.96034 6.0995 7.64316 5.8008 7.33714 5.49258C7.19099 5.34539 7.21977 5.1143 7.36973 4.97519C7.51922 4.83649 7.75983 4.81721 7.91508 4.95743C8.23178 5.24344 8.53933 5.53897 8.84149 5.83891C8.9024 5.89937 8.92274 5.99678 8.96178 6.07716Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M15.5735 6.49437C15.3948 6.47091 15.2657 6.40194 15.1934 6.25403C15.1218 6.10747 15.1325 5.95728 15.2489 5.84168C15.5508 5.54162 15.8593 5.24704 16.1749 4.96C16.332 4.81715 16.5816 4.83641 16.7311 4.98034C16.8758 5.11952 16.8973 5.35354 16.7513 5.4995C16.4472 5.8035 16.1327 6.09838 15.8142 6.3887C15.7538 6.44367 15.6547 6.46014 15.5735 6.49437Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.6391 3.80236C11.6391 3.66392 11.6361 3.52541 11.6398 3.38705C11.6456 3.17091 11.8159 3.00648 12.0352 3.00018C12.2516 2.99395 12.4462 3.15113 12.4545 3.36397C12.4659 3.65775 12.4657 4.14602 12.455 4.43984C12.447 4.65903 12.2504 4.81583 12.0254 4.80575C11.8065 4.79594 11.6441 4.63163 11.6395 4.41122C11.6367 4.27283 11.639 3.94081 11.6391 3.80236Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.4137 10.8622C16.4137 13.2746 14.4581 15.2302 12.0457 15.2302C9.63334 15.2302 7.67773 13.2746 7.67773 10.8622C7.67773 8.44987 9.63334 6.49426 12.0457 6.49426C14.4581 6.49426 16.4137 8.44987 16.4137 10.8622ZM14.6672 10.8625C14.6672 9.41513 13.4938 8.24176 12.0464 8.24176V13.4833C13.4938 13.4833 14.6672 12.31 14.6672 10.8625Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M8.70313 17.6554C8.26373 16.9906 8.74048 16.104 9.53738 16.104H14.544C15.3429 16.104 15.8193 16.9946 15.3757 17.6591L15.0742 18.1109C14.8887 18.3888 14.5766 18.5558 14.2425 18.5558H9.83597C9.50021 18.5558 9.18686 18.3873 9.00172 18.1072L8.70313 17.6554Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.8819 17.2545C21.6278 16.9051 21.3742 16.5553 21.1153 16.2093C21.0557 16.1297 21.0392 16.0563 21.0548 15.9602C21.2062 15.0278 21.7634 13.4991 21.4929 12.6098C21.3241 12.055 21.1416 11.504 20.9635 10.9518C20.6 9.82459 20.0568 8.14143 19.872 7.57081C19.6872 7.00019 18.96 6.62868 18.4366 7.11174C17.9179 7.59041 18.1746 8.40356 18.3778 9.06847C18.5755 9.71537 18.8023 11.1388 18.5665 12.6211C18.3306 14.1037 17.6418 15.3533 17.2877 15.9209C17.1856 16.0842 16.7578 16.5905 17.4717 17.5657C17.8998 18.1506 18.327 18.7362 18.7587 19.3186C18.9825 19.6203 19.2039 19.7921 19.5429 19.5577C20.2168 19.0909 21.1023 18.3969 21.7734 17.9264C22.0333 17.7442 22.0701 17.5133 21.8819 17.2545Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.0002 13.5546C16.9904 13.1085 17.3297 12.7386 17.7581 12.7284C18.1865 12.7182 18.5417 13.0715 18.5515 13.5177L18.6187 16.5788C18.6284 17.0249 18.2891 17.3948 17.8608 17.405C17.4324 17.4152 17.0772 17.0619 17.0674 16.6157L17.0002 13.5546Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M2.11813 17.2545C2.37218 16.9051 2.62577 16.5553 2.88468 16.2093C2.94429 16.1297 2.96083 16.0563 2.94523 15.9602C2.79381 15.0278 2.23662 13.4991 2.50713 12.6098C2.6759 12.055 2.85841 11.504 3.03654 10.9518C3.39998 9.82459 3.94322 8.14143 4.128 7.57081C4.31279 7.00019 5.04001 6.62868 5.56344 7.11174C6.08211 7.59041 5.8254 8.40356 5.6222 9.06847C5.42452 9.71537 5.19773 11.1388 5.43354 12.6211C5.66939 14.1037 6.35817 15.3533 6.71229 15.9209C6.81438 16.0842 7.2422 16.5905 6.52834 17.5657C6.1002 18.1506 5.67298 18.7362 5.24127 19.3186C5.01746 19.6203 4.79611 19.7921 4.45706 19.5577C3.78319 19.0909 2.89773 18.3969 2.22662 17.9264C1.96675 17.7442 1.92994 17.5133 2.11813 17.2545Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M7.00028 13.5546C7.01007 13.1085 6.67076 12.7386 6.24239 12.7284C5.81403 12.7182 5.45883 13.0715 5.44903 13.5177L5.38184 16.5788C5.37204 17.0249 5.71136 17.3948 6.13973 17.405C6.56809 17.4152 6.92329 17.0619 6.93308 16.6157L7.00028 13.5546Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default MuteluIcon;
